import React, { useEffect, useRef } from 'react';
import classNames from 'clsx';
import { useMeasure } from '@wix/fast-gallery-navigator';
import ItemRenderer from './ItemRenderer';
import { GALLERY_EVENTS } from '@wix/fast-gallery-library';
import { renderCustomOrDefaultComp } from '../utils';
const Item = _ref => {
  let {
    index,
    data,
    selectors,
    customRenderers,
    eventsListener,
    onMeasure,
    activeIndex
  } = _ref;
  const itemRef = useRef(null);
  const [isActive, setIsActive] = React.useState(false);
  useEffect(() => {
    setIsActive(index === activeIndex);
  }, [activeIndex, index]);
  useMeasure({
    callback: measurements => onMeasure(index, measurements, itemRef),
    index,
    ref: itemRef
  });
  const itemRendererProps = {
    data,
    selectors,
    customRenderers,
    eventsListener
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: itemRef,
    className: classNames('item', selectors == null ? void 0 : selectors.item, isActive ? 'active' : ''),
    role: "listitem",
    onClick: () => eventsListener(GALLERY_EVENTS.ON_ITEM_CLICKED, data)
  }, renderCustomOrDefaultComp(customRenderers == null ? void 0 : customRenderers.itemRenderer, ItemRenderer, itemRendererProps));
};
export default Item;
//# sourceMappingURL=Item.js.map